/*
 *
 * Home reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_PLANS,
  LOAD_PLANS,
  LOAD_PLANS_SUCCESS,
  LOAD_PLANS_ERROR,
  CHANGE_PLANS,
  CHANGE_PLANS_SUCCESS,
  CHANGE_PLANS_ERROR,
  DELETE_PLANS,
  DELETE_PLANS_SUCCESS,
  DELETE_PLANS_ERROR,
} from './constants';

export const initialState = {
  loading: false,
  error: false,
  deleteSuccessful: false,
  plansList: false,
  plansData: false,
};

/* eslint-disable default-case, no-param-reassign */
const plansReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_PLANS:
        return initialState;

      // LOAD
      case LOAD_PLANS:
        draft.loading = true;
        draft.error = false;
        break;

      case LOAD_PLANS_SUCCESS:
        draft.plansList = action.plansList;
        draft.loading = false;
        break;

      case LOAD_PLANS_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // CHANGE/UPDATE
      case CHANGE_PLANS:
        draft.plansData = { ...state.plansData, ...action.plansData };
        draft.loading = true;
        draft.error = false;
        break;

      case CHANGE_PLANS_SUCCESS:
        draft.loading = false;
        const { plansData } = action;
        draft.plansData = plansData;

        // update single item in the list inside state
        let listData = draft.plansList.data;
        let index = draft.plansList.data.findIndex(
          po => po._id === plansData._id,
        );
        index !== -1
          ? (listData[index] = plansData)
          : listData.unshift(plansData);
        draft.plansList = { ...draft.plansList, data: listData };

        break;

      case CHANGE_PLANS_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // DELETE
      case DELETE_PLANS:
        draft.loading = true;
        draft.id = action.id;
        break;

      case DELETE_PLANS_SUCCESS:
        draft.loading = false;
        draft.deleteSuccessful = true;
        break;
    }
  });

export default plansReducer;
